<template>
  <v-container id="containerLandingAC">
    <v-row justify="center">
      <v-col cols="12" align="center">
        <h1> {{ title }}</h1>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" align="center" style="text-align: center">
        <p>
          <b style="color: #44E0B2">Byppay</b>
          {{ $t('LandingAC. is a digital system that makes it easier for all those entrepreneurs to pay their providers through potential clients in times of crisis in a fast, cheap and safe way.') }}
        </p>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" align="center">
        <v-btn color="primary" style="border-radius: 10px" @click="goToFactoring">
          {{ buttonText }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-img style="height: 100%" src="../../public/wellcomeImages/BYPPAY-07.png" />
        <span>{{ $t('Register to byppay.com') }}</span>
      </v-col>
      <v-col cols="6">
        <v-img style="height: 100%" src="../../public/wellcomeImages/BYPPAY-10.png" />
        <span>{{ certificateText }}</span>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" align="center">
        <v-carousel
          hide-delimiter-background
          show-arrows-on-hover
          :show-arrows="false"
          height="70vh"
          :dark="darkMode"
          :light="!darkMode"
        >
          <v-carousel-item v-for="(img) in imgs" :key="img.img">
            <v-row justify="center">
              <v-col cols="12" style="text-align: center" align="center">
                <img style="height: 100%; max-height: 200px; max-width: 250px" :src="img.img">
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12">
                <h1>{{ img.title }}</h1>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" align="center" style="text-align: center">
                <p><b>{{ img.description }}</b></p>
              </v-col>
            </v-row>
          </v-carousel-item>
        </v-carousel>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" align="center">
        <v-btn color="primary" style="border-radius: 10px" @click="$router.push({name: 'imageInvoice', replace: true})">
          {{ $t('UPLOAD INVOICE') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: "LandingA",
    data () {
        return {
            imgs: [{img: "/wellcomeImages/BYPPAY-16.png", title: "RÀPID", description: "Gràcies a la seva tecnologia BlockChain, Byppay permet crear en poques hores un acord de pagament directe entre clients i proveïdors"}, {img: "/wellcomeImages/BYPPAY-14.png", title: "ECONÒMIC", description: "Byppay evita les conseqüències de ser intermediari entre client i proveïdor. Byppay no depèn de cap banc"}, {img: "/wellcomeImages/BYPPAY-13.png", title: "SEGUR", description: "Byppay utilitza tecnologia DLT per assegurar els acords de pagaments entre client-proveïdor."}],
            title: "",
            buttonText: "",
            certificateText: "",
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            if (this.$route.query.isA) {
                this.title = this.$t('PAY ') + this.$route.query.bCif + this.$t(' NOW');
                this.buttonText = this.$t('PAY NOW');
                this.certificateText = this.$t('Pay your invoice and obtain your certificate');
            } else {
                this.title = this.$t('RECIEVE PAYMENT OF ') + this.$route.query.bCif;
                this.buttonText = this.$t('RECIEVE PAYMENT NOW');
                this.certificateText = this.$t('Recieve your payment and obtain your certificate');
            }
        },
        goToFactoring () {
            this.$router.push({name: 'SpecificCompensation',  query: { id: this.$route.query.Pageid.toString(), userId: this.$route.query.userId.toString()}});
        }
    }
};
</script>

<style>
#containerLandingAC{
  font-family: "ChampagneAndLimousines", Helvetica, sans-serif;
}
</style>
